import React, { createContext, useEffect } from 'react';
import { useState } from 'react';
import { countries } from '../utils/countries';
import { IndiaContent } from '../assets/content/indiaContent.js';
import { IndonesiaContent } from '../assets/content/indonesiaContent.js';
import { MalaysiaContent } from '../assets/content/malaysiaContent.js';
import { ThailandContent } from '../assets/content/thailandContent.js';
import { basicAuth, basicAuthMy, basicAuthTh } from '../Api/crmPortal.js';
import axios from 'axios';
import { toast } from 'react-toastify';
export const MyContext = createContext();

const Context = (props) => {
  const [count, setCount] = useState(0);
  const [index, setIndex] = useState(0);
  const [heightAct, setHeightAct] = useState(false);
  const [ownerPlanTabActive, setOwnerPlanTabActive] = useState(0);
  const [country, setCountry] = useState(null);
  const [pageData, setPageData] = useState(IndiaContent);
  const pathname = window.location.pathname;
  const path = window.location.href.split('/')[3];
  const [language, setLanguage] = useState('en');
  const [tenantList, setTenantList] = useState([]);
  const [tenantId, settenantId] = useState(6);
  const [auth, setAuth] = useState(basicAuth);

  // Indonesia: Try using 202.62.16.0
  // Malaysia: Try using 175.136.0.0
  // thailand: Try using 110.164.0.0
  // Test for other countries: 112.135.0.1
  // useEffect(() => {
  //   fetch('https://geolocation-db.com/json/')
  //     .then((response) => response.json())
  //     .then((data) => {
  //       countryCode = countries.find(
  //         (country) => country.name === data.country_name
  //       );
  //       const countryPath = countries.find((country) => country.value === path);
  //       if (countryCode?.value && !path) setCountry(countryCode?.value);
  //       else if (path === 'in') {
  //         setCountry('in');
  //         setPageData(IndiaContent);
  //       } else if (path === 'id') {
  //         setCountry('id');
  //         setLanguage('id');
  //         setPageData(IndonesiaContent);
  //       } else if (path === 'my') {
  //         setCountry('my');
  //         setLanguage('my');
  //         setPageData(MalaysiaContent);
  //       } else if (path === 'th') {
  //         setCountry('th');
  //         setLanguage('th');
  //         setPageData(ThailandContent);
  //       } else if (!countryPath) {
  //         setCountry('cs');
  //         setPageData(IndiaContent);
  //       } else {
  //         setCountry('cs');
  //         setPageData(IndiaContent);
  //       } // Full country name (e.g., "India")
  //     })
  //     .catch((error) => console.error('Error fetching location:', error));
  //   getTenantsList(countryCode);
  // }, []);
  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await fetch('https://ipwho.is/');
        // const response = await fetch('https://geolocation-db.com/json/');
        const data = await response.json();
        handleCountryData(data);
      } catch (error) {
        console.error('Error fetching location:', error);
      }
    };

    const handleCountryData = (data) => {
      const countryCode = countries.find(
        (country) => country.name === data.country
      );

      // const countryCode = countries.find(
      //   (country) => country.name === data.country_name
      // );

      const countryPath = countries.find((country) => country.value === path);

      if (countryCode?.value && !path) {
        setCountry(countryCode?.value);
      } else {
        handlePathBasedCountry(path, countryPath);
      }

      getTenantsList(countryPath?.value);
    };

    const handlePathBasedCountry = (path, countryPath) => {
      switch (path.toLowerCase()) {
        case 'in':
          setCountry('in');
          setPageData(IndiaContent);
          break;
        case 'id':
          setCountry('id');
          setLanguage('id');
          setPageData(IndonesiaContent);
          break;
        case 'my':
          setCountry('my');
          setLanguage('my');
          setPageData(MalaysiaContent);
          setAuth(basicAuthMy);
          break;
        case 'th':
          setCountry('th');
          setLanguage('th');
          setPageData(ThailandContent);
          setAuth(basicAuthTh);
          break;
        case 'googleadsleadgen':
          setCountry('googleadsleadgen');
          setLanguage('googleadsleadgen');
          setPageData(IndiaContent);
          break;
        default:
          if (!countryPath) {
            setCountry('cs');
            setPageData(IndiaContent);
          } else {
            setCountry('cs');
            setPageData(IndiaContent);
          }
          break;
      }
    };

    fetchCountryData();
  }, []);

  const getTenantsList = async (countryCode) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CRM_URL}/tenancy/all`,
        basicAuth
      );
      if (response?.data) {
        setTenantList(response?.data);
        // Find tenantId based on shortCountryCode
        const tenant = response.data.find(
          (tenant) => tenant.shortCountryCode === countryCode
        );

        if (tenant) {
          settenantId(tenant.tenantId);
          return tenant?.tenantId;
        } else {
          console.warn(`No tenant found for country code: ${country}`);
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  };
  console.log('tenantId', tenantId, country);
  const getInspectionPlans = async () => {
    try {
      let tenantIdData = await getTenantsList(country);
      const apiUrl = `${process.env.REACT_APP_CRM_URL}/inspectionpackagepairs/activepackagesfortenantid?tenantId=${tenantIdData}`;
      let authData = basicAuth;
      if (country == 'my') {
        authData = basicAuthMy;
        setAuth(basicAuthMy);
      }
      console.log('auth', authData);
      const response = await axios.get(apiUrl, authData);
      const inspectionData = parseInspectionFeatures(response?.data);
      return inspectionData;
    } catch (error) {
      console.log('error', error);
    }
  };
  function parseInspectionFeatures(packages) {
    return packages?.map((item) => ({
      ...item,
      smallPackage: item?.smallPackage
        ? {
            ...item.smallPackage,
            inspectionFeatures: item?.smallPackage?.inspectionFeatures
              ? JSON.parse(item?.smallPackage?.inspectionFeatures)
              : null,
            addonFeatures: item?.smallPackage?.addonFeatures
              ? JSON.parse(item?.smallPackage?.addonFeatures)
              : null,
          }
        : null,
      highPackage: item?.highPackage
        ? {
            ...item.highPackage,
            inspectionFeatures: item?.highPackage?.inspectionFeatures
              ? JSON.parse(item?.highPackage?.inspectionFeatures)
              : null,
            addonFeatures: item?.highPackage?.addonFeatures
              ? JSON.parse(item?.highPackage?.addonFeatures)
              : null,
          }
        : null,
    }));
  }

  const createLeadfromHero = async (formData) => {
    try {
      console.log('formData', formData, country, tenantId);
      const obj = {
        sourceId: '17099787275_' + formData?.city,
        channel: 'google',
      };
      const encoded = encodeURIComponent(JSON.stringify(obj));
      const flatParams = {
        tenantId: tenantId,
        name: formData.name,
        phoneNumber: formData?.phoneCode + formData.phone,
        leadmsg: encoded,
      };
      const queryParams = new URLSearchParams(flatParams).toString();
      const apiWithParams = `${process.env.REACT_APP_CRM_URL}/leads/quickconnect?${queryParams}`;
      console.log('apiWithParams', apiWithParams);
      let authData = basicAuth;
      if (country == 'my') {
        authData = basicAuthMy;
        setAuth(basicAuthMy);
      }
      const response = await axios.post(apiWithParams, {}, authData);
      if (response?.status === 200)
        toast.success('Report published successfully!');
      return response;
    } catch (error) {
      console.log('error', error);
    }
  };
  return (
    <MyContext.Provider
      value={{
        count,
        setCount,
        index,
        setIndex,
        heightAct,
        setHeightAct,
        ownerPlanTabActive,
        setOwnerPlanTabActive,
        country,
        countries,
        setPageData,
        pageData,
        setCountry,
        language,
        setLanguage,
        tenantList,
        getInspectionPlans,
        tenantId,
        auth,
        createLeadfromHero,
      }}
    >
      {props.children}
    </MyContext.Provider>
  );
};
export default Context;
